import WizardRegistration from './container'
export { WizardRegistration }
export default WizardRegistration